import { colors } from '../../constants';
const MuiAlert = {
  root: {
    display: 'grid',
    gridAutoFlow: 'column',
    gridTemplateColumns: '1fr auto 1fr',
    opacity: 0.85,
    '& a': {
      fontWeight: 'bold'
    }
  },
  icon: {
    justifySelf: 'end',
    marginTop: -3,
    marginBottom: -3,
    '& .MuiSvgIcon-root': {
      fontSize: 28
    }
  },
  message: {
    justifySelf: 'center'
  },
  action: {
    marginLeft: 0,
    justifySelf: 'end'
  },
  filledError: {
    '& a:hover': {
      color: colors.error.dark
    }
  },
  filledInfo: {
    '& a:hover': {
      color: colors.info.dark
    }
  },
  filledSuccess: {
    '& a:hover': {
      color: colors.success.dark
    }
  },
  filledWarning: {
    '& a:hover': {
      color: colors.warning.dark
    }
  },
  outlinedError: {
    '& a:hover': {
      color: colors.error.dark
    }
  },
  outlinedInfo: {
    '& a:hover': {
      color: colors.info.dark
    }
  },
  outlinedSuccess: {
    '& a:hover': {
      color: colors.success.dark
    }
  },
  outlinedWarning: {
    '& a:hover': {
      color: colors.warning.dark
    }
  },
  standardError: {
    '& a:hover': {
      color: colors.error.dark
    }
  },
  standardInfo: {
    '& a:hover': {
      color: colors.info.dark
    }
  },
  standardSuccess: {
    '& a:hover': {
      color: colors.success.dark
    }
  },
  standardWarning: {
    '& a:hover': {
      color: colors.warning.dark
    }
  }
};
export default MuiAlert;